module.exports = __webpack_public_path__ + "static/media/321.076fcd1c.mp3";